module.exports = __webpack_public_path__ + "static/media/cards_logos.9f43aed9.png";